module.exports = __webpack_public_path__ + "img/993490336.71a43467.jpg";